// For now we have to disable unsafe assignment for all reducers
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { IGlobalConfigState } from "../store/IRcaState";
import { AnyAction } from "@reduxjs/toolkit";
import initialState from "../store/initialState";
import {
  SET_LANGUAGE_COMPLETE,
  TOGGLE_NAV,
  SET_AUTOFILL_ENABLED,
  SET_COOKIE_CONSENT_REQUIRED,
  DISMISS_BANNER_COMPLETE,
  REFRESH_ANTIFORGERY_TOKEN,
  SET_THEME,
} from "../actions/actionTypes";

/**
 * The redux reducer for the globalConfiguration section of the state
 *
 * @param state - The current application state
 * @param action - The action that is being processed
 * @returns - The (possibly) updated state
 */
export const globalConfigReducer = (state: IGlobalConfigState = initialState.globalConfig, action: AnyAction): IGlobalConfigState => {
  switch (action.type) {
    case SET_LANGUAGE_COMPLETE:
      return { ...state, language: action.language, langDir: action.langDir };
    case SET_AUTOFILL_ENABLED:
      return { ...state, autoFillEnabled: action.enabled };
    case TOGGLE_NAV:
      return { ...state, showNav: !state.showNav };
    case SET_COOKIE_CONSENT_REQUIRED:
      return { ...state, cookieConsentRequired: action.required };
    case DISMISS_BANNER_COMPLETE: {
      const entry = action.value as {
        /**
         * The banner ID.
         */
        bannerId: string;
        /**
         * The timestamp.
         */
        timestamp: Date;
      };
      return { ...state, bannersDismissed: { ...state.bannersDismissed, ...{ [entry.bannerId]: entry.timestamp } } };
    }
    case REFRESH_ANTIFORGERY_TOKEN:
      return { ...state, antiForgeryToken: action.antiForgeryToken };
    case SET_THEME:
      return { ...state, themeName: action.themeName };
    default:
      return state;
  }
};
